import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SingleTicketPageComments from "../SingleTicketPageComments";

const TicketDetailsModal = ({ open, handleClose, ticket, userType }) => {
    console.log(typeof ticket, "ticket")
  if (!ticket) return null;

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          minWidth: 400,
          maxWidth: "80%",
          maxHeight: "80%",
          overflowY: "auto",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <SingleTicketPageComments userType={userType} ticketID={ticket} />
      </Box>
    </Modal>
  );
};

export default TicketDetailsModal;
